import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "document-block-menu",
  ref: "root"
}
const _hoisted_2 = ["onMousedown"]
const _hoisted_3 = ["onMousedown"]
const _hoisted_4 = ["onMousedown"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      class: "document-block-menu__button",
      type: "button",
      onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toggleMenu && _ctx.toggleMenu(...args)), ["stop"])),
      "aria-label": "document actions"
    }, [...(_cache[3] || (_cache[3] = [
      _createElementVNode("i", { class: "icons8-more" }, null, -1)
    ]))]),
    (_ctx.showMenu)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["document-block-menu__panel", { "document-block-menu__panel--left": _ctx.menuPositionLeft }]),
          onMousedown: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"])),
          onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"]))
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.topActions, (item) => {
            return (_openBlock(), _createElementBlock("button", {
              class: "document-block-menu__item",
              key: item.key,
              type: "button",
              onMousedown: _withModifiers(($event: any) => (_ctx.runAction(item.key)), ["prevent"])
            }, _toDisplayString(_ctx.$t(item.titleKey)), 41, _hoisted_2))
          }), 128)),
          _cache[4] || (_cache[4] = _createElementVNode("hr", { class: "mt-05 mb-05" }, null, -1)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.middleActions, (item) => {
            return (_openBlock(), _createElementBlock("button", {
              class: "document-block-menu__item",
              key: item.key,
              type: "button",
              onMousedown: _withModifiers(($event: any) => (_ctx.runAction(item.key)), ["prevent"])
            }, _toDisplayString(_ctx.$t(item.titleKey)), 41, _hoisted_3))
          }), 128)),
          _cache[5] || (_cache[5] = _createElementVNode("hr", { class: "mt-05 mb-05" }, null, -1)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.bottomActions, (item) => {
            return (_openBlock(), _createElementBlock("button", {
              class: "document-block-menu__item",
              key: item.key,
              type: "button",
              onMousedown: _withModifiers(($event: any) => (_ctx.runAction(item.key)), ["prevent"])
            }, _toDisplayString(_ctx.$t(item.titleKey)), 41, _hoisted_4))
          }), 128))
        ], 34))
      : _createCommentVNode("", true)
  ], 512))
}